import * as React from 'react';
import { SVGProps } from 'react';

const SvgPlusOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <rect x={4} y={11} width={16} height={2} rx={1} fill="currentColor" />
    <rect
      x={13}
      y={4}
      width={16}
      height={2}
      rx={1}
      transform="rotate(90 13 4)"
      fill="currentColor"
    />
  </svg>
);

export default SvgPlusOutlined;
